/**
 * Created by esri on 3/1/2016.
 */

var urls = {
    pardot: {
        http: 'http://cdn.pardot.com/pd.js',
        https: 'https://pi.pardot.com/pd.js'
    },
    // domainService: document.location.protocol + '//webnode.esri.com/3012/rest/pardot/domain'
};

//************************************
//  Lookup Domain
//************************************
function lookupDomain() {
    var domain;

    domain = pardot_domains.filter(function (entry) {
        return entry.name.toLowerCase() == window.location.host;
    })[0];

    return domain;
}

//************************************
//  Init Pardot
//************************************
function initPardot(domain) {
    //Set Pardot Tad IDs
    if (!domain) {
        domain = {piAId: 83202, piCId: 4012, adobe_scripts: []}
    }
    piAId = domain.piAId;
    piCId = domain.piCId;

    //Include Pardot.js (ssl vs http)
    if (document.location.protocol == 'https:') {
        writeScriptTag(urls.pardot.https);
    } else {
        writeScriptTag(urls.pardot.http);
    }
}

//************************************
//  Helper Functions
//************************************
function writeScriptTag(scriptUrl) {
    document.write('<script src="' + scriptUrl + '" type="text/javascript"></script>');
}

(function init() {
    var domain = lookupDomain();
    initPardot(domain);
})();


